<div #conversationContainer class="conversation-container">
  <ng-container
    *ngFor="let message of messages; let index = index; let last = last"
  >
    <div
      [ngClass]="{
        'message-container': true,
        'user-message': message.from === 'user',
        'bot-message': message.from === 'bot'
      }"
    >
      <!-- User & Bot Avatar -->
      <div class="avatar">
        <ng-container
          *ngIf="
            message.from === 'bot' &&
            (message.queryType == 'userInput' ||
              message.queryType == 'queryClarification' ||
              last)
          "
        >
          <img [src]="imgPath" alt="Avatar" />
        </ng-container>
        <ng-container *ngIf="message.from === 'user'">
          <i
            class="fas fa-user-circle user-circle ms-1 mt-1"
            style="font-size: 24px"
          ></i>
        </ng-container>
      </div>

      <!-- User & Bot Conversation -->
      <div
        class="message"
        *ngIf="
          message.text?.greeting ||
          (!message.text?.greeting &&
            !message.text?.categories &&
            getDataType(message.text) == 'string')
        "
      >
        <ng-container *ngIf="message.text?.greeting">
          <p class="unset-margin">{{ message.text.greeting }}</p>
        </ng-container>

        <ng-container
          *ngIf="!message.text?.greeting && !message.text?.categories"
        >
          <p
            *ngIf="message.from === 'bot'"
            class="unset-margin"
            [innerHTML]="message.text | brTag"
          ></p>
          <p *ngIf="message.from === 'user'" class="unset-margin">
            {{ message.text }}
          </p>
        </ng-container>
      </div>
    </div>

    <div
      *ngIf="
        message.text?.categories ||
        (!message.text?.greeting && !message.text?.categories) ||
        getDataType(message.text) == 'object'
      "
      class="query-options"
    >
      <ng-container *ngIf="message.text?.categories && last">
        <ng-container *ngFor="let query of message.text.categories">
          <button
            (click)="proceed(query, 'category')"
            class="query-option-btn ms-1 mt-1"
          >
            {{ query }}
          </button>
        </ng-container>
      </ng-container>

      <ng-container
        *ngIf="!message.text?.greeting && !message.text?.categories && last"
      >
        <ng-container *ngIf="getDataType(message.text) == 'object'">
          <ng-container *ngFor="let question of message.text">
            <button
              (click)="proceed(question, 'question')"
              class="query-option-btn ms-1 mt-1"
            >
              {{ question.question }}
            </button>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>

    <button
      *ngIf="!isShowPrompt && message.from == 'bot' && last"
      (click)="showPrompt()"
      class="other-option-btn align-opt-btn mt-1"
    >
      Other queries...
    </button>
  </ng-container>

  <ng-container *ngIf="isTyping">
    <app-typing-three-dot-loader></app-typing-three-dot-loader>
  </ng-container>

  <div class="mt-2 align-opt-btn" *ngIf="messages.length > 4">
    <ng-container *ngFor="let btn of queryNavigator">
      <button
        (click)="getQuery(btn.value == 'main' ? 0 : messages.length - 3)"
        class="query-nav-btn mt-1 ms-1"
      >
        {{ btn.label | titlecase }}
      </button>
    </ng-container>
  </div>
</div>
